import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Comment, useViewFilterQuery } from '@uncinc/react-drupal-core';

import { Pager } from '../../../../components';

const ViewPostComments = (props) => {
  const {
    entities,
    pager,
    originalPosterId,
    onClickReply,
  } = props;

  const { page, setCurrentPage } = useViewFilterQuery();
  const pageParam = useSelector((state) => state.getIn(['router', 'location', 'query', 'page']));
  const hash = useSelector((state) => state.getIn(['router', 'location', 'hash'], ''));

  const totalPages = pager.get('total_pages', 0);

  useEffect(() => {
    // If there is no url param for the current page,
    // set the current page to the last page.
    if (!pageParam) {
      setCurrentPage(totalPages);
    }
  }, [pageParam, totalPages]);

  return (
    <div className="ViewPostComments">
      <Pager
        totalPages={totalPages}
        setCurrentPage={(page) => {
          setCurrentPage(page);
          window.scrollTo(0, 0);
        }}
        currentPage={page + 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        controlled
      />

      {entities.map((comment) => {
        const id = comment.getIn(['cid', 0, 'value']);
        const uuid = comment.getIn(['uuid', 0, 'value']);
        const langcode = comment.getIn(['langcode', 0, 'value']);
        const authorId = comment.getIn(['uid', 0, 'target_id']);
        const isOriginalPoster = authorId === originalPosterId;

        return (
          <Comment
            key={`${uuid}:${langcode}`}
            id={id}
            entity={comment}
            viewMode="teaser"
            isOriginalPoster={isOriginalPoster}
            onClickReply={onClickReply}
          />
        );
      })}

      <Pager
        totalPages={totalPages}
        setCurrentPage={(page) => {
          setCurrentPage(page);
          window.scrollTo(0, 0);
        }}
        currentPage={page + 1}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        controlled
      />
    </div>
  );
};

export default ViewPostComments;
